import {
  accountingFormatOptions,
  currencyOptions as defaultCurrencyOptions,
} from 'constants/loanApplication';

export const LoanFeePayerEnum = {
  BORROWER: 'Buyer',
  SELLER: 'Seller',
  LENDER: 'Lender',
  OTHER: 'Other',
};

export const LoanFeePaymentTimeEnum = {
  AT_CLOSING: 'At closing',
  BEFORE_CLOSING: 'Before closing',
};

export const ExtraFeesFieldsMapper = {
  feeTypeName: [
    'feeName',
    'monthsCollected',
    'feeProviderName',
    'prepaidInterestDescription',
    'impoundTypeName',
    'monthlyAmount',
    'description',
    'name',
    'startDate',
    'endDate',
  ],
  amount: [
    'cashToCloseAmount',
    'kTotalAmount',
    'closingCostsPayedBeforeClosing',
    'totalLoanAmount',
    'sellerCreditAmount',
    'loanAmount',
    'giftsFund',
    'lTotalAmount',
    'totalCollected',
    'prepaidInterestAmount',
    'manualDailyPrepaidInterest',
    'monthsCollected',
    'monthlyAmount',
    'aggregateAdjustment',
    'closingCostsPaidAtClosingSectionJ',
    'salePriceOfProperty',
    'totalAmount',
  ],
  totalAtClosingAmount: ['lenderCredit'],
};

const FeeCreditSource = {
  LENDER: 0,
  SELLER: 1,
  OTHER: 2,
};

export const FeeCreditSourceLabel = {
  [FeeCreditSource.LENDER]: 'Lender',
  [FeeCreditSource.SELLER]: 'Seller',
  [FeeCreditSource.OTHER]: 'Other',
  Lender: 'Lender',
  Seller: 'Seller',
  Other: 'Other',
};

export const getCreditTargetBucket = creditSource => {
  if (creditSource === FeeCreditSource.SELLER || creditSource === 'Seller') {
    return 'sellerPaidAtClosingAmount';
  }

  return 'paidByOthersAmount';
};

export const feeCreditSourceOptions = [
  { name: FeeCreditSourceLabel[FeeCreditSource.LENDER], value: FeeCreditSource.LENDER },
  { name: FeeCreditSourceLabel[FeeCreditSource.SELLER], value: FeeCreditSource.SELLER },
  { name: FeeCreditSourceLabel[FeeCreditSource.OTHER], value: FeeCreditSource.OTHER },
];

export const ModifiedFieldsMapper = {
  feeTypeId: 'feeTypeName',
  feeProviderId: 'feeProviderName',
};

export const currencyOptions = {
  ...defaultCurrencyOptions,
  ...accountingFormatOptions,
  minimumFractionDigits: 2,
};
